import request from '../../utils/request';

const ErpService = {
  searchCustomers: (search: any) =>
    request('/erp/customers/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    }),

  upsertCustomer: (payload: any) =>
    request('/erp/customers/upsert', {
      method: 'POST',
      body: JSON.stringify({ request: payload }),
    }),

  deleteCustomer: (id: number) =>
    request('/erp/customers/delete', {
      method: 'POST',
      body: JSON.stringify({ request: id }),
    }),

  searchSuppliers: (search: any) =>
    request('/erp/suppliers/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    }),

  upsertSupplier: (payload: any) =>
    request('/erp/suppliers/upsert', {
      method: 'POST',
      body: JSON.stringify({ request: payload }),
    }),

  deleteSupplier: (id: number) =>
    request('/erp/suppliers/delete', {
      method: 'POST',
      body: JSON.stringify({ request: id }),
    }),

  searchProducts: (search: any) =>
    request('/erp/products/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    }),

  upsertProduct: (payload: any) =>
    request('/erp/products/upsert', {
      method: 'POST',
      body: JSON.stringify({ request: payload }),
    }),

  deleteProduct: (id: number) =>
    request('/erp/products/delete', {
      method: 'POST',
      body: JSON.stringify({ request: id }),
    }),

  searchCustomerInvoices: (search: any) =>
    request('/erp/customer-invoices/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    }),

  upsertCustomerInvoice: (payload: any) =>
    request('/erp/customer-invoices/upsert', {
      method: 'POST',
      body: JSON.stringify({ request: payload }),
    }),

  deleteCustomerInvoice: (id: number) =>
    request('/erp/customer-invoices/delete', {
      method: 'POST',
      body: JSON.stringify({ request: id }),
    }),

  downloadCustomerInvoicePdf: (id: number) =>
    request(
      '/erp/customer-invoices/pdf',
      {
        method: 'POST',
        body: JSON.stringify({ request: id }),
      },
      true,
    ),

  searchSupplierInvoices: (search: any) =>
    request('/erp/supplier-invoices/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    }),

  upsertSupplierInvoice: (payload: any) =>
    request('/erp/supplier-invoices/upsert', {
      method: 'POST',
      body: JSON.stringify({ request: payload }),
    }),

  deleteSupplierInvoice: (id: number) =>
    request('/erp/supplier-invoices/delete', {
      method: 'POST',
      body: JSON.stringify({ request: id }),
    }),

  downloadSupplierInvoicePdf: (id: number) =>
    request(
      '/erp/supplier-invoices/pdf',
      {
        method: 'POST',
        body: JSON.stringify({ request: id }),
      },
      true,
    ),
};

export default ErpService;
